import React from 'react';
import { Divider, Flex } from '@chakra-ui/react';
import { KText } from '@/ui-library/components/text';
import { AiScoreInterfaces } from '../../AiScoreInterface';
import { Stars03 } from '@kula-ai/icons-core';
import { AutoRejectSection } from '../../AiScoringDrawer/AutoRejectSection';

type AttributeListProps = {
  attributes: AiScoreInterfaces.AiScoreApiAttribute[];
};

const AttributeList: React.FC<AttributeListProps> = ({ attributes }) => {
  const sortedAttributes = Array.isArray(attributes)
    ? [...attributes].sort((a, b) => a.position - b.position)
    : [];

  return (
    <Flex flexDir="column" gap="24px">
      {sortedAttributes?.map(
        (attribute) =>
          attribute?.description && (
            <Flex key={attribute.id} gap="12px" alignItems="center">
              <Stars03
                size={20}
                gradient={{
                  direction: 'vertical',
                  colors: [
                    { offset: '0%', color: '#797DFF' },
                    { offset: '100%', color: '#680AF5' },
                  ],
                }}
              />
              <KText>{attribute?.description}</KText>
            </Flex>
          )
      )}
    </Flex>
  );
};

export const AiScoringJobInfoList: React.FC<
  AiScoreInterfaces.AiScoringListProps
> = ({
  attributes,
  autoRejectEnabledState,
  setAutoRejectEnabledState,
  autoRejectThresholdState,
  setAutoRejectThresholdState,
}) => {
  return (
    <Flex flexDir="column">
      <Flex flexDir="column" p="22px 16px 17px 27px" gap="16px">
        <KText variant="heading_4">Candidate attributes</KText>
        <Divider color="secondary-100" />
        <AttributeList attributes={attributes} />
      </Flex>
      <AutoRejectSection
        enabled={autoRejectEnabledState}
        onToggle={setAutoRejectEnabledState}
        threshold={autoRejectThresholdState}
        onThresholdChange={setAutoRejectThresholdState}
        containerProps={{ w: '100%', p: '12px 27px', borderRadius: '0' }}
      />
    </Flex>
  );
};
